import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const currentUser = createAsyncThunk('auth/userInfo',
  async () => {
    const url = 'v1/user-info'
    const response: AxiosResponse<Users> = await instance.get(url)
    return response.data
  })
